// Polis, the Scenarios tab (16 October 2026): possible candidacies and their scenarios.
export default {
  chargement: 'Loading…',
  erreur: 'The scenarios could not be loaded.',
  reessayer: 'Try again',
  titre: 'Candidacies and their scenarios',
  texte: 'Who could still declare, how likely they are to, and what each combination of candidacies would give in the first round.',
  dernierPoint: 'Candidacies last reviewed on {jour}; reviewed again every Monday.',
  refaire: 'Review now',
  refaitEnCours: 'Review under way: a few minutes.',
  pct: '{n}%',
  fourchette: '{bas} ~ {haut}',
  probabiliteAria: '{nom}: {p}% chance of declaring',
  voirDetail: 'See details',
  masquer: 'Hide',
  exclusif: 'Only one candidacy with: {noms}',
  possibles: {
    titre: 'Possible candidacies',
    legende: 'the probability of declaring, and what it rests on',
    aucune: 'No possible candidacy found: every followed candidate has declared.',
  },
  prediction: {
    titre: 'Orion’s prediction',
    selonJumeaux: 'from the twins projection, polls for reference',
    selonSondages: 'from the poll projection: the twins ratings will come with the next wave',
    sondages: 'polls {p}',
    premierTour: 'First round',
    secondTour: 'Most likely runoff',
    vainqueur: 'The winner',
    chanceDuel: '{p} of cases',
    contre: 'against {p} for {nom}',
    duelAMesurer: 'This runoff will be measured at the next wave.',
    vainqueurAMesurer: 'The winner will be predicted once a wave has measured the runoffs.',
    nonMesure: 'runoffs not measured: {p}',
  },
  secondTour: {
    aLieu: 'happens in {p} of scenarios',
    titre: 'The runoff',
    legende: 'each likely duel, the share of scenarios where it happens, and what the twins would do in it, among valid votes',
    chance: '{nom} wins in {p} of cases',
    aria: '{a} {pa}%, {b} {pb}%',
    retrait: 'Blank, void or abstention: {p}',
  },
  central: {
    titre: 'The most likely scenario',
    legende: 'candidacy by candidacy; first round projected from the {vague}',
    sansVague: 'candidacy by candidacy; its first round is projected at the next wave',
  },
  duels: {
    titre: 'The possible runoffs',
    legende: 'across every combination of candidacies, each weighted by its probability',
    face: '{a} vs {b}',
  },
  jumeaux: {
    titre: 'What the twins alone say',
    legende: 'Each twin rated each candidate; their preferences are their own. Only how sharply they choose between the candidates they like is tuned on polls, never a candidate’s level.',
    ecart: '{n} points from the polls on average, on the candidates polls test.',
  },
  variations: {
    titre: 'What each possible candidacy changes',
    legende: 'against the most likely scenario',
    si: 'If {nom} runs',
    siPas: 'If {nom} does not run',
    ferait: '{nom} would get {p} in the first round.',
    feraitCourt: '{p} in the first round',
    nonMesureCourt: 'no twin mentions them yet',
    points: '{n} pt',
    secondChange: 'The runoff changes: {a} and {b}.',
    secondIdem: 'The runoff does not change.',
    nonMesure: 'No twin mentions {nom}, neither for themselves nor around them: they do not weigh in this panel yet.',
  },
  scenarios: {
    titre: 'The most likely scenarios',
    base: 'projected from the {vague}',
    sansVague: 'their first round is projected at the next wave',
    central: 'The central scenario',
    numero: 'Scenario {n}',
    avec: 'With',
    sans: 'Without',
    declaresSeuls: 'Declared candidates only',
    second: 'Runoff: {a} and {b}',
    aMesurer: 'This scenario will be projected at the next wave, which will also include its candidates.',
  },
}
